import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'

/**
 * Component that automatically generates a new diagram ID and redirects to it
 * This ensures every diagram has an ID from the start, making save operations cleaner
 */
export const NewDiagramRedirect: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // Generate a new UUID for the diagram
    const newId = uuidv4()

    // Redirect to the new diagram URL
    navigate(`/diagram/${newId}`, { replace: true })
  }, [navigate])

  // Show a brief loading state while redirecting
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent dark:border-blue-400" />
        <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
          Creating new diagram...
        </p>
      </div>
    </div>
  )
}
